import {
  userAuth,
  userHome,
  footer,
  userProfile,
  userChangePassword,
  userSupport,
  createMemories,
  biographies,
  theme,
  userSavedCard,
  payment,
} from "./User";
import { appLanguage as common } from "./Common/index.i18n";
import { appLanguage as adminAuth } from "./Admin/Auth/index.i18n";
import {
  adminCms,
  adminUserManagement,
  adminUpdateProfile,
  adminReportCategory,
  adminSubscription,
  coupen,
} from "./Admin";

export default function lang() {
  return {
    text: {
      common: common.text,
      userHome: userHome.text,
      userAuth: userAuth.text,
      footer: footer.text,
      adminAuth: adminAuth.text,
      adminUserManagement: adminUserManagement.text,
      adminUpdateProfile: adminUpdateProfile.text,
      adminReportCategory: adminReportCategory.text,
      userProfile: userProfile.text,
      adminCms: adminCms.text,
      userChangePassword: userChangePassword.text,
      userSupport: userSupport.text,
      createMemories: createMemories.text,
      biographies: biographies.text,
      theme: theme.text,
      adminManageSubscription: adminSubscription.text,
      userSavedCard: userSavedCard.text,
      payment: payment.text,
      coupen: coupen.text,
    },
    validation: {
      auth: userAuth.validation,
      common: common.validation,
      adminAuth: adminAuth.validation,
      adminUserManagement: adminUserManagement.validation,
      adminUpdateProfile: adminUpdateProfile.validation,
      adminReportCategory: adminReportCategory.validation,
      userProfile: userProfile.validation,
      adminCms: adminCms.validation,
      userAuth: userAuth.validation,
      userChangePassword: userChangePassword.validation,
      userSupport: userSupport.validation,
      createMemories: createMemories.validation,
      biographies: biographies.validation,
      theme: theme.validation,
      adminManageSubscription: adminSubscription.validation,
      userSavedCard: userSavedCard.validation,
      coupen: coupen.validation,
    },
  };
}
